module.exports = __webpack_public_path__ + "img/circle_chk.6247d642.svg";